import styled from '@emotion/styled'
import SearchInput from 'components/patterns/Inputs/SearchInputV2'
import { HoverableInfoIcon } from 'components/patterns'
import { stylesIf } from 'utils/styles'

export const SearchWrapper = styled.div((props) => {
  const { hasLabel } = props
  return `
    display: flex;
    flex-direction: ${hasLabel ? `column` : `row`};
  `
})

export const SearchInputField = styled(SearchInput)((props) => {
  const { width } = props
  return `
    width: ${width || `500px`};
  `
})

export const SearchInfoIcon = styled(HoverableInfoIcon)`
  display: block;
`

export const SearchLabel = styled.div((props) => {
  const { labelType } = props
  return `
${stylesIf(
  labelType === 'label',
  `
  label {
    color: var(--Black-Black-Secondary, rgba(7, 7, 15, 0.70));
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
  `,
  `
  margin-bottom: 4px;

  h3,
  span {
    display: inline;
  }
  `
)}
`
})
